var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPredefinedOfferRecommendedIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 8.885L9.09 10.75L8.27 7.235L11 4.87L7.405 4.565L6 1.25L4.595 4.565L1 4.87L3.73 7.235L2.91 10.75L6 8.885Z",
  fill: "#5F1341"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPredefinedOfferRecommendedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/predefined-offer-recommended-icon.f84666862fc59fa3d89450059f207270.svg";